export default __webpack_public_path__ + "static/media/homepage_module_satisfaction.15675849.png";